import {c as createCommonjsModule} from "./_commonjsHelpers-8c19dec8.js";
import {c as core} from "./index-0a000c27.js";
var dialogTitleClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getDialogTitleUtilityClass = getDialogTitleUtilityClass;
  function getDialogTitleUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiDialogTitle", slot);
  }
  const dialogTitleClasses = (0, core.generateUtilityClasses)("MuiDialogTitle", ["root"]);
  var _default = dialogTitleClasses;
  exports.default = _default;
});
export {dialogTitleClasses_1 as d};
